var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"products-and-footer"},[_c('machines'),_c('hr'),_c('bigankiseries'),_c('hr'),_c('swseries'),_c('hr'),_c('plseries'),_c('hr'),_c('acseries'),_c('hr'),_c('hmseries'),_c('hr'),_c('drmedicseries'),_c('hr'),_c('kilominus'),_c('hr'),_c('scfooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }